import * as React from 'react'
import { useTranslate } from '../../src/hooks/useTranslate'
import { ProductTypeFilterSetting } from '../../src/model/fragments'
import { Checkbox } from '../Checkbox'
import { CheckboxList } from '../CheckboxList'
import { useSetFilterPreview } from '../Filter'

interface ToggleProps {
	label: React.ReactNode
	isChecked: boolean
	onChange: (value: boolean) => void
}

const FeatureSelectInner: React.FC<ToggleProps> = ({
	label,
	isChecked,
	onChange,
}) => (
	<Checkbox
		label={label}
		control={{
			checked: isChecked,
			onChange: (event) => {
				const { target } = event.nativeEvent
				if (target instanceof HTMLInputElement) {
					const { checked } = target
					onChange(checked)
				}
			},
			disabled: false,
		}}
	/>
)


export const FeatureSelect : React.FC<{setting: ProductTypeFilterSetting['attributes'], onChange: (attrs: ProductTypeFilterSetting['attributes']) => void}> = 
({ setting, onChange}) => {
	const translate = useTranslate();

	const [usedFilters, setUsedFilters] = React.useState(0);
	const [filter, setFilter] = React.useState<ProductTypeFilterSetting['attributes']>(setting ?? {antislip: false, rideableByCar: false});
	const setFilterPreview = useSetFilterPreview()

	React.useEffect(() => {
		setFilterPreview(usedFilters ? 'Upravit' : null);

		if(usedFilters > 0)
		{
			onChange(filter);
		}
		else 
		{
			onChange(null);
		}

	}, [setFilterPreview, usedFilters])

	if(!setting)
	{
		return <></>;
	}

	return (
		<CheckboxList
			items={[
				<FeatureSelectInner
					isChecked={filter!.antislip ?? false}
					label={translate('filter-antislip')}
					onChange={(value: boolean) =>{
						setFilter({...filter, antislip: value});
						setUsedFilters(usedFilters + (value ? 1 : -1))
					}}
				/>,
				<FeatureSelectInner
					isChecked={filter!.rideableByCar ?? false}
					label={translate('filter-rideable-by-car')}
					onChange={(value: boolean) =>{
						setFilter({...filter, rideableByCar: value});
						setUsedFilters(usedFilters + (value ? 1 : -1))
					}}
				/>,
			]}
		/>
	)
}
